import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { Color } from 'core';
import React from 'react';
import styled from 'styled-components';
import { SupportLink } from './SupportLink';

const SUPPORT_URL = 'https://www.cerego.com/support/what-are-mirrored-assignments';

export const MirroredTooltip = () => {
  return (
    <LightTooltip
      title={
        <TooltipParagraph>
          Mirrored assignments are assignments that are shared across multiple courses, offering efficiency and
          consistency by reflecting changes across all instances of the assignment.
        </TooltipParagraph>
      }
      interactive
    >
      <SupportLink type="button" url={SUPPORT_URL} />
    </LightTooltip>
  );
};

const TooltipParagraph = styled.p`
  font-size: 14px;
`;

const LightTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: Color.white,
    color: Color.primaryBlack,
    border: `1px solid ${Color.reportGray}`,
    boxShadow: `3px 3px 3px ${Color.reportGray}`,
  },
}))(Tooltip);
